const doc = [({"da":({"js":({"admin":({"show_box_attributes":({"form":({"the_attribute_was_saved":"Attributten blev gemt."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;